import { NextSeo } from 'next-seo';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MinimalLayout from '@/src/layouts/MinimalLayout';
import { urlHostResolver } from '@/src/lib/utils';
import ScheduleView from '@/src/views/root/ScheduleView';

export default function OrdersPage() {
  return (
    <AssembleLayout Layout={MinimalLayout} Component={ScheduleView}>
      <NextSeo
        title="Agendar demonstração"
        description="Encontre uma data e horário para agendar a demonstração com nossa equipe e conhecer os benefícios da nossa plataforma."
        openGraph={{
          title: 'Agendar demonstração',
          url: urlHostResolver('/schedule'),
        }}
      />
    </AssembleLayout>
  );
}
